import {
  CircleDashed,
  Clapperboard,
  Copy,
  KeyRound,
  Settings,
  Stamp,
  Type,
  Users
} from 'lucide-react';
import type { EnterpriseWorkspaceSettingsRoutes } from 'v5/core/routing/appRouting';
import { NavLink } from 'v5/platform/react-router';
import { MenuItem, MenuSeparator } from 'v5/patterns/sidebar/Menu';

export function renderEnterpriseWorkspaceSettingsItems(
  wsSettings: EnterpriseWorkspaceSettingsRoutes,
  level = 1,
  options?: {
    canConfigureResourceTypes?: boolean;
    resourceTypesLabel?: string;
  }
) {
  const canConfigureResourceTypes = options?.canConfigureResourceTypes ?? true;
  const resourceTypesLabel = options?.resourceTypesLabel ?? 'Resource types';

  return (
    <>
      <NavLink to={wsSettings.general()}>
        <MenuItem level={level} icon={<Settings className="size-4" />}>
          General
        </MenuItem>
      </NavLink>
      <NavLink to={wsSettings.users()}>
        <MenuItem level={level} icon={<Users className="size-4" />}>
          Users
        </MenuItem>
      </NavLink>
      <NavLink to={wsSettings.permissionGroups()}>
        <MenuItem level={level} icon={<KeyRound className="size-4" />}>
          Permission groups
        </MenuItem>
      </NavLink>

      <MenuSeparator level={level} />

      {canConfigureResourceTypes ? (
        <NavLink to={wsSettings.resourceTypes()}>
          <MenuItem level={level} icon={<Type className="size-4" />}>
            {resourceTypesLabel}
          </MenuItem>
        </NavLink>
      ) : null}
      <NavLink to={wsSettings.resourceDuplicates()}>
        <MenuItem level={level} icon={<Copy className="size-4" />}>
          Resource duplicates
        </MenuItem>
      </NavLink>

      <MenuSeparator level={level} />

      <NavLink to={wsSettings.bookingTypes()}>
        <MenuItem level={level} icon={<Stamp className="size-4" />}>
          Booking types
        </MenuItem>
      </NavLink>
      <NavLink to={wsSettings.bookingWorkflow()}>
        <MenuItem level={level} icon={<CircleDashed className="size-4" />}>
          Booking workflow
        </MenuItem>
      </NavLink>

      <MenuSeparator level={level} />

      <NavLink to={wsSettings.productionTypes()}>
        <MenuItem level={level} icon={<Clapperboard className="size-4" />}>
          Production types
        </MenuItem>
      </NavLink>
      <NavLink to={wsSettings.productionWorkflow()}>
        <MenuItem level={level} icon={<CircleDashed className="size-4" />}>
          Production workflow
        </MenuItem>
      </NavLink>
    </>
  );
}
